import _defineProperty from 'babel-runtime/helpers/defineProperty';
import { getOptionProps, initDefaultProps } from '../_util/props-util';
import classNames from 'classnames';
import { GalleryProps } from './interface';
import { ConfigConsumerProps } from '../config-provider';
import Icon from '../icon';

export default {
  name: 'FaUploadGallery',
  props: initDefaultProps(GalleryProps, {
    wrapWidth: 600,
    viewWidth: 600,
    iconSize: 'default',
    defaultIndex: 0
  }),
  data: function data() {
    return {
      index: this.defaultIndex
    };
  },

  inject: {
    configProvider: { 'default': function _default() {
        return ConfigConsumerProps;
      } }
  },
  computed: {
    // 计算属性代理index, 实现有范围的自动取值
    proxyIndex: {
      get: function get() {
        return this.index;
      },
      set: function set(index) {
        var maxIndex = this.maxIndex,
            minIndex = this.minIndex;

        this.index = index > maxIndex ? maxIndex : index < minIndex ? minIndex : index;
      }
    },
    maxIndex: function maxIndex() {
      return Math.ceil(this.viewWidth / this.wrapWidth) - 1;
    },
    minIndex: function minIndex() {
      return 0;
    }
  },
  watch: {
    viewWidth: function viewWidth(val) {
      var _this = this;

      var scrollLeft = this.proxyIndex * this.wrapWidth;
      var maxScrollLeft = val - this.wrapWidth;
      var scrollLeftTarget = scrollLeft > maxScrollLeft ? maxScrollLeft : scrollLeft;

      setTimeout(function () {
        _this.scrollToLeft(_this.$refs.wrap, scrollLeftTarget, 300);
      }, 100);
    },
    proxyIndex: function proxyIndex(val) {
      var _this2 = this;

      var scrollLeft = val * this.wrapWidth;
      var maxScrollLeft = this.viewWidth - this.wrapWidth;
      var scrollLeftTarget = scrollLeft > maxScrollLeft ? maxScrollLeft : scrollLeft;

      setTimeout(function () {
        _this2.scrollToLeft(_this2.$refs.wrap, scrollLeftTarget, 300);
      }, 100);
    }
  },
  methods: {
    slideToPrev: function slideToPrev() {
      this.proxyIndex--;
    },
    slideToNext: function slideToNext() {
      this.proxyIndex++;
    },
    slideToLast: function slideToLast() {
      this.proxyIndex = this.maxIndex;
    },
    slideToFirst: function slideToFirst() {
      this.proxyIndex = this.minIndex;
    },
    scrollToLeft: function scrollToLeft(element, target, duration) {
      if (element.scrollLeft === target) return;

      var distance = target - element.scrollLeft;
      var scrollX = element.scrollLeft,
          oldTimestamp = null;

      function step(newTimestamp) {
        if (oldTimestamp !== null) {
          scrollX += Math.ceil(distance * (newTimestamp - oldTimestamp) / duration);

          if (distance > 0) {
            if (scrollX >= target) {
              element.scrollLeft = target;
              return;
            }
          } else {
            if (scrollX <= target) {
              element.scrollLeft = target;
              return;
            }
          }
          element.scrollLeft = scrollX;
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
  },
  render: function render() {
    var _classNames, _classNames2;

    var h = arguments[0];

    var _getOptionProps = getOptionProps(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        wrapWidth = _getOptionProps.wrapWidth,
        viewWidth = _getOptionProps.viewWidth,
        iconSize = _getOptionProps.iconSize;

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('upload', customizePrefixCls);

    var proxyIndex = this.proxyIndex,
        minIndex = this.minIndex,
        maxIndex = this.maxIndex,
        slideToPrev = this.slideToPrev,
        slideToNext = this.slideToNext;


    var prevButtonClasses = classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + '-gallery-button', true), _defineProperty(_classNames, prefixCls + '-gallery-button-prev', true), _defineProperty(_classNames, prefixCls + '-gallery-button-' + iconSize, true), _defineProperty(_classNames, prefixCls + '-gallery-button-disabled', proxyIndex === minIndex), _classNames));

    var nextButtonClasses = classNames((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-gallery-button', true), _defineProperty(_classNames2, prefixCls + '-gallery-button-next', true), _defineProperty(_classNames2, prefixCls + '-gallery-button-' + iconSize, true), _defineProperty(_classNames2, prefixCls + '-gallery-button-disabled', proxyIndex === maxIndex), _classNames2));

    var wrapStyles = {
      width: wrapWidth + 1 + 'px'
    };

    var viewStyles = {
      width: viewWidth + 'px'
    };

    return h(
      'div',
      { 'class': prefixCls + '-gallery-wrapper', attrs: { 'data-index': proxyIndex, 'data-max-index': maxIndex }
      },
      [h('div', [maxIndex > 0 ? h(
        'div',
        { 'class': prevButtonClasses, on: {
            'click': slideToPrev
          }
        },
        [h(Icon, {
          attrs: { type: 'left' }
        })]
      ) : null]), h(
        'div',
        { ref: 'wrap', 'class': prefixCls + '-gallery-wrap', style: wrapStyles },
        [h(
          'div',
          { 'class': prefixCls + '-gallery-view', style: viewStyles },
          [this.$slots['default']]
        )]
      ), h('div', [maxIndex > 0 ? h(
        'div',
        { 'class': nextButtonClasses, on: {
            'click': slideToNext
          }
        },
        [h(Icon, {
          attrs: { type: 'right' }
        })]
      ) : null])]
    );
  }
};